import React from "react";
import {
  ArrowRight,
  Sparkles,
  GraduationCap,
  Users,
  Target,
  MapPin,
} from "lucide-react";
import { useTheme } from "../../../context/ThemeContext";
import { Link } from "react-router-dom";

function HeroInternship() {
  const { theme } = useTheme();

  const stats = [
    { icon: GraduationCap, value: "5000+", label: "Students Trained" },
    { icon: Users, value: "50+", label: "Partner Companies" },
    { icon: Target, value: "100%", label: "Practical Learning" },
    { icon: MapPin, value: "15+", label: "Branches Available" },
  ];

  return (
    <section className="relative min-h-screen overflow-hidden bg-white dark:bg-[#050505] pt-32 px-6 lg:px-16 pb-10 transition-all duration-300">
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary/20 blur-[140px] rounded-full"></div>
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/20 blur-[140px] rounded-full"></div>

      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.03)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:70px_70px]"></div>

      <div className="relative z-10 max-w-7xl mx-auto grid lg:grid-cols-[55%,45%] gap-12 items-center">
        <div>
          <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full border border-primary/20 bg-primary/10 backdrop-blur-xl mb-3">
            <Sparkles className="w-4 h-4 text-primary" />
            <span className="text-sm text-primary font-medium tracking-wide">
              Polytechnic Technical Internship Programme
            </span>
          </div>

          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 dark:text-white">
            Polytechnic Technical
            <span className="block bg-gradient-to-r from-primary via-orange-400 to-yellow-400 bg-clip-text text-transparent">
              Internship for Students
            </span>
          </h1>

          <h2 className="font-dancing mysubheading text-gray-800 dark:text-gray-200">
            Best Technical Internship Programme for Polytechnic Students
          </h2>

          <p className="myparagraph text-gray-900 dark:text-gray-300 leading-normal">
            Join Web X Secure’s Polytechnic Internship Programme in Jodhpur and
            learn practical skills in web development, digital marketing,
            graphic design, AI tools, programming, and real-world projects.
          </p>

          <div className="flex flex-wrap gap-2 mt-3">
            {[
              "Global Level Certificate",
              "Live Projects",
              "Industry Mentorship",
              "Placement Assistance",
            ].map((item, index) => (
              <div
                key={index}
                className="px-3 py-1 border border-primary/30 dark:border-white/10 bg-white/70 dark:bg-white/5 text-primary text-xs rounded"
              >
                {item}
              </div>
            ))}
          </div>

          <div className="mt-6 flex flex-wrap gap-5">
            <Link
              to="https://webxsecure.in/contact"
              className="group flex items-center gap-2 px-5 py-2 rounded-lg bg-primary text-white font-semibold shadow-[0_0_40px_rgba(254,120,83,0.35)] hover:scale-105 transition-all duration-300"
            >
              Get Internship Details
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition" />
            </Link>

            <Link
              to="https://webxsecure.in/case-study"
              target="_blank"
              className="px-5 py-2 rounded-lg border border-primary/30 dark:border-white/10 bg-white/70 dark:bg-white/5 backdrop-blur-xl text-gray-800 dark:text-white font-medium hover:scale-105 transition-all duration-300"
            >
              View Projects
            </Link>
          </div>
        </div>

        <div className="relative flex justify-center items-center">
          <div className="absolute w-[450px] h-[450px] bg-primary/20 blur-[120px] rounded-full"></div>
          <div className="absolute w-[350px] h-[350px] bg-orange-300/20 blur-[120px] rounded-full"></div>

          <div className="relative group">
            <div className="relative rounded-[30px] border border-black/5 dark:border-white/10 bg-white/70 dark:bg-white/5 backdrop-blur-2xl p-3 shadow-[0_0_60px_rgba(254,120,83,0.15)]">
              <img
                src={
                  theme === "light"
                    ? "polytechnic-internhsip.png"
                    : "internship.png"
                }
                alt="Polytechnic internship programme in Jodhpur"
                className="w-full max-w-[720px] rounded-[24px] object-cover"
              />
            </div>
          </div>
        </div>
      </div>

      {/* STATS BAR */}
      <div className="relative z-20 max-w-6xl mx-auto mt-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 rounded-xl border border-black/5 dark:border-white/10 bg-white/90 dark:bg-white/5 backdrop-blur-2xl shadow-[0_0_60px_rgba(0,0,0,0.08)] dark:shadow-[0_0_60px_rgba(254,120,83,0.12)] px-6 py-6">
          {stats.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={index}
                className="flex items-center justify-center gap-4 lg:border-r lg:last:border-r-0 border-gray-200 dark:border-white/10"
              >
                <Icon className="w-9 h-9 text-primary" />
                <div>
                  <h3 className="text-3xl font-bold text-gray-900 dark:text-white">
                    {item.value}
                  </h3>
                  <p className="text-sm font-medium text-gray-500 dark:text-gray-300">
                    {item.label}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default HeroInternship;
